import React from 'react';
import { Cell, List, ListDataRefresher, TextField } from 'ui-builder';
import UpdateLabelButton from './UpdateLabelButton';
import DeleteLabelButton from './DeleteLabelButton';
import DocumentField from '../../../shared/file/DocumentField';
import RenameLabelFileButton from './RenameLabelFileButton';
import { LABELS_UPDATED, useDocumentLabelsService } from 'nekst-api';
import { GridLayout } from 'features/nekst-widgets';

export default function DocumentLabelsList() {
  const documentLabelService = useDocumentLabelsService();
  return (
    <List
      getDataFunc={documentLabelService.getLabels}
    >
      <GridLayout weights={[5, 5, 2]} noDataMessage="No document labels created">
        <TextField label="Name" source="name" />
        <Cell label="Universal Document">
          <DocumentField source="fileId" label="Document" fileDataSource="_file" />
          <RenameLabelFileButton />
        </Cell>
        <Cell label="Actiions">
          <UpdateLabelButton />
          <DeleteLabelButton />
        </Cell>
      </GridLayout>
      <ListDataRefresher eventName={LABELS_UPDATED} />
    </List>
  );
}
